<template>
    <el-dialog title="导入机构名单" :show-close="false" :close-on-click-modal="false" :visible.sync="importInsListVisble" class="addMechanismDialog" width="500px" :before-close="importBeforeClose">
        <div class="dialog_contenter">
            <el-upload ref="importUpload"
             class="upload-demo" 
             :before-remove="beforeRemove" 
             action="" 
             :file-list="file"
             multiple :auto-upload="false" 
             :on-change="handleChange"
             :on-remove="handleRemove"
             accept=".xlsx">
                <!-- <el-button size="small" type="primary">选择文件</el-button> -->
                <div class="uploadBox">
                        <i class="el-icon-folder-opened" style="font-size: 40px;"></i>
                    <span>选择文件</span>
                </div>
                <div style="width: 200px; text-align: left;"><span style="color: red;">*</span> 注意</div>
                <div slot="tip" class="el-upload__tip">
                    1.请使用模版文件导入 <a :href="uploadUrl">下载模版</a>
                </div>
            </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="() => {
                    file = []
                    $emit('changeimportInsListVisble', false)
                }">取 消</el-button>
            <el-button size="mini" type="primary" @click="SaveBtn">保 存</el-button>
        </span>
    </el-dialog>

</template>

<script>
import fetch from '@/api/fetch.js'
export default {
    name: 'basicDialog',

    data() {
        return {
            file: [],
        };
    },
    props: {
        importInsListVisble: { // 是否显示
            type: Boolean,
            default() {
                return false
            }
        },
        uploadUrl: {
            type: String,
            default() {
                return ''
            }
        },
        isApplication: {
            type: Boolean,
            default() {
                return false
            }
        }

    },

    mounted() {

    },

    methods: {
        handleChange(file, fileList) {
            this.file = fileList
        },
        // 删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。function(file, fileList)
        handleRemove(file, fileList) {
            this.file = fileList
        }, 
        // eslint-disable-next-line no-unused-vars
        beforeRemove(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        importBeforeClose() {
            this.$emit('changeimportInsListVisble', false)
        },
        SaveBtn() {
            if (this.file.length === 0) {
                return this.$message.warning('请选取文件后再上传')
            }
            let formData = new FormData();
            this.file.forEach((file) => {// 因为要上传多个文件，所以需要遍历
                console.log(file)
                formData.append('file', file.raw);
            })
            if(this.isApplication) {
                fetch.getimportInsOrgList(formData).then(res => {
                    if(res.code == '0') {
                        this.$message.success(res.msg)
                    } else {
                        this.$message.success(res.msg)
                    }
                    this.fileList = []
                })  
            } else {
                fetch.getimportBatchApply(formData).then(res => {
                    if(res.code == '0') {
                        this.$message.success(res.msg)
                        
                    } else {
                        this.$message.success(res.msg)
                    }
                    this.fileList = []
                })
            }
            
        }

    },
};
</script>

<style lang="scss" scoped>
.addMechanismDialog {
    /deep/.el-dialog__footer {
        text-align: center;
    }
    /deep/.el-dialog__header {
        border-bottom: 1px solid #ccc;
    }
    /deep/ .el-dialog__title {
        font-size: 14px;
    }
    /deep/ .el-dialog__body {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    /deep/.dialog_contenter {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    /deep/ .el-upload {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .upload-demo {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
        /deep/.el-upload-list {
            text-align: center;
        }
    }
    .uploadBox {
        width: 100px;
        height: 100px;
        border: 1px solid #ccc;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 40px;
        margin-top: 20px;
        div {
            width: 50px;
            height: 50px;
            background-color: #ccc;
        }
    }
}
</style>